module.exports = __webpack_public_path__ + "static/media/fbtb_logo_sketches.a79f1143.png";